// getCookie function
export function getCookie(cookie_key) {
  var key = cookie_key + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var split_val = decodedCookie.split(';');
  for(var i = 0; i < split_val.length; i++) {
      var temp = split_val[i];
      while (temp.charAt(0) == ' ') {
          temp = temp.substring(1);
      }
      if (temp.indexOf(key) == 0) {
          return temp.substring(key.length, temp.length);
      }
  }
  return "";
}

export function setCookie(cookie_nmae, cookie_value, expire_days) {
    var date = new Date();
    date.setTime(date.getTime() + (expire_days*24*60*60*1000));
    var expires = "expires="+ date.toUTCString();
    document.cookie = cookie_nmae + "=" + cookie_value + ";" + expires + ";path=/";
}


// WEBPACK FOOTER //
// ./src/assets/js/elffy_js/cookie.js